module.exports = __webpack_public_path__ + "img/demo_reel_th.d9049814.png";